import React, { useState, useEffect } from "react";
import { Table, Button, Form, Image, Col } from "react-bootstrap";
import { UserFavoritesRestaurantTableHead } from "../UserFavoritesTable/UserFavoritesRestaurantTableHead";
import { UserFavoritesRestaurantTablebody } from "../UserFavoritesTable/UserFavoritesRestaurantTablebody";
import { FormControl, Select, InputLabel } from "@material-ui/core";
import BasicPagination from "../../../../Pagination/Pagination";
import { getAllFavouritesRestaurant } from "../../../../../store/actions/AdminAllUserFavourites/userAllFavourites";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { AmealioLoader } from "../../../../Loader/AmealioLoader";
import moment from "moment";
import SelectFilter from "../../../../reusableComponents/selectFilter";
import { SortComponent } from "../../../../reusableComponents/SortAndFilterComponent/SortComponent";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import isEmpty from "../../../../../store/validation/is-Empty";
import CSVDownloader from "../../../../reusableComponents/csvDownload/csvDownload";
import { Menu, MenuItem } from "@material-ui/core";
// Animations
import styled, { keyframes } from "styled-components";
import { zoomIn } from "react-animations";
import NoContent from "../../../../reusableComponents/NoContentComponent";
const zoomAnimation = keyframes`${zoomIn}`;
const ZoomDiv = styled.div`
  animation: 1s ${zoomAnimation};
`;

const UserFavoritesRestaurant = (props) => {
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const [displaySearch, setDisplaySearch] = useState(false);
  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  const [dateQuery, setDateQuery] = useState({
    startDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  });

  const onDateChangeHandler = (data, type) => {
    setDateQuery(data);
  };

  useEffect(() => {
    if (!isEmpty(dateQuery)) {
      setLoading(true);
      props.getAllFavouritesRestaurant(
        dateQuery.startDate,
        dateQuery.endDate,
        onSuccesGetRestaurant,
        onErrorrGetRestaurant
      );
    }
  }, [dateQuery]);

  const onErrorrGetRestaurant = () => {
    setLoading(false);
  };
  const onSuccesGetRestaurant = () => {
    setLoading(false);
  };

  const [state, setState] = useState({
    anchorEl: null,
    search: "",
  });
  const [restaurantReverse, setRestaurantReverse] = useState("");

  /**********************************
   * @DESC Sort And Filter Methods
   *********************************/
  const handleClick = (event) => {
    setState({
      ...state,
      anchorEl: event.currentTarget,
    });
  };
  const handleClose = () => {
    setState({
      ...state,
      anchorEl: null,
    });
  };
  const handleSelect = (value) => (e) => {
    setRestaurantReverse(value);
    handleClose();
  };

  /*********************************
   * @DESC Search Bar Action
   *********************************/
  const onClickSearchButtonTop = () => {
    setDisplaySearch(!displaySearch);
  };

  const onSearchChange = (e) => {
    setState({
      ...state,
      search: e.target.value,
    });
  };

  const [restaurantFav, setRestaurantFav] = useState([]);

  const statusTypes = [
    { id: 0, title: "All" },
    { id: 1, title: "Favourite added" },
    { id: 2, title: "Favourite removed" },
  ];

  const userFilter = [
    { title: "User Activity", disabled: true },
    { title: `Date & Time 🠑`, disabled: false },
    { title: "Date & Time 🠓", disabled: false },
  ];

  const [statusType, setstatusType] = useState("All");
  const [userSort, setUserSort] = useState("");
  const [showFilter, setShowFilter] = useState(false);

  const handleShowFilter = () => {
    setShowFilter(!showFilter);
  };

  const searchClick = () => {
    setShowFilter(!showFilter);
  };
  const cancelClick = () => {
    setShowFilter(!showFilter);
  };

  useEffect(() => {
    if (props.userRestaurantFavourites) {
      const items = props.userRestaurantFavourites;
      const reversedItems = items.map((item) => item).reverse();
      setRestaurantFav(reversedItems);
    }
  }, [props.userRestaurantFavourites]);

  let downloadData = {
    headers: [
      { label: "Restaurant Id", key: "_id" },
      { label: "Restaurant Name", key: "name" },
      { label: "User Name", key: "user_name" },
      { label: "Date Time", key: "date_time" },
      { label: "Comments", key: "comments" },
      { label: "Status", key: "status" },
    ],
    data: restaurantFav.map((restaurant) => {
      return {
        _id: `${restaurant?.restaurant_id?._id}`,
        name: `${restaurant?.restaurant_id?.restaurant_name}`,
        user_name: `${restaurant?.user_id?.first_name}`,
        date_time: `${moment(restaurant?.updatedAt).format("DD/MM/YYYY") +
          " " +
          moment(restaurant?.updatedAt).format("LT")
          }`,
        comments: `${restaurant?.message}`,
        status: `${restaurant?.message === "Favourite was added" ? "ON" : "OFF"
          }`,
      };
    }),
  };

  let filteredData = [];
  if (restaurantReverse === "A-Z") {
    filteredData = restaurantFav.sort((a, b) => {
      if (a?.restaurant_id?.restaurant_name < b?.restaurant_id?.restaurant_name)
        return -1;
      if (a?.restaurant_id?.restaurant_name > b?.restaurant_id?.restaurant_name)
        return 1;
      return 0;
    });
  } else if (restaurantReverse === "Z-A") {
    filteredData = restaurantFav.sort((a, b) => {
      if (a?.restaurant_id?.restaurant_name < b?.restaurant_id?.restaurant_name)
        return 1;
      if (a?.restaurant_id?.restaurant_name > b?.restaurant_id?.restaurant_name)
        return -1;
      return 0;
    });
  }
  if (state.search) {
    let search = new RegExp(state.search, "i");
    filteredData = restaurantFav.filter((getall) => {
      if (search.test(getall?.restaurant_id?.restaurant_name)) {
        return getall;
      } else if (search.test(getall?.restaurant_id?.city)) {
        return getall;
      } else if (
        search.test(
          getall?.user_id?.first_name + " " + getall?.user_id?.last_name
        )
      ) {
        return getall;
      } else {
        return false;
      }
    });
  } else {
    filteredData = restaurantFav;
  }

  if (statusType) {
    filteredData = filteredData.filter((item) => {
      if (statusType === "Favourite added") {
        return item?.message === "Favourite was added";
      } else if (statusType === "Favourite removed") {
        return item?.message === "Favourite was removed";
      } else {
        return item;
      }
    });
  }
  if (userSort === "Date & Time 🠑") {
    filteredData = filteredData.sort(
      (a, b) => new Date(a.updatedAt) - new Date(b.updatedAt)
    );
  } else if (userSort === "Date & Time 🠓") {
    filteredData = filteredData.sort(
      (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
    );
  }

  const renderTableDataBody = (restaurant) => {
    return (
      <React.Fragment>
        <UserFavoritesRestaurantTablebody
          restaurantImage={
            restaurant.restaurant_id && restaurant.restaurant_id.logo_url
          }
          restaurantName={
            restaurant.restaurant_id && restaurant.restaurant_id.restaurant_name
          }
          restaurantId={
            restaurant.restaurant_id && restaurant.restaurant_id._id
          }
          //userImage={require("../../../../../assets/images/ActionImages/demoprofile.jpg")}
          userImage={
            restaurant.user_id && restaurant.user_id.profile_photo[0]
              ? restaurant.user_id && restaurant.user_id.profile_photo[0]
              : require("../../../../../assets/images/ActionImages/demoprofile.jpg")
          }
          userName={restaurant.user_id && restaurant.user_id.first_name}
          userDate={moment(restaurant.updatedAt).format("DD/MM/YYYY")}
          userTime={moment(restaurant.updatedAt).format("LT")}
          comments={restaurant.message}
          status={
            restaurant.message === "Favourite was added" ? (
              <> ON </>
            ) : (
              <> OFF </>
            )
          }
        />
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      {!loading ? <></> : <AmealioLoader />}
      <div className="super-admin-rating-review-tab super-admin-issues-open-users-tab row mb-2">
        <div className="col-4">
          <div className="d-flex align-items-center">
            <Image
              alt="Search"
              title="Search"
              width="80px"
              src={require("../../../../../assets/images/iconButton/newsearchicon.svg")}
              onClick={() => onClickSearchButtonTop()}
            />
            {/* <SortComponent
              handleClick={handleClick}
              anchorEl={state.anchorEl}
              handleClose={handleClose}
              selectClick={(data) => handleSelect(data)}
            /> */}
            <div>
              <div
                className="f10-400"
                align="center"
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={handleClick}
              >
                <img
                  src={require("../../../../../assets/images/iconButton/sortbtn.svg")}
                  width="80px"
                />
              </div>
              <Menu
                id="simple-menu"
                anchorEl={state.anchorEl}
                keepMounted
                open={Boolean(state.anchorEl)}
                onClose={handleClose}
              >
                {userFilter.map((ele, index) => {
                  return (
                    <MenuItem
                      value={ele.title}
                      key={index}
                      onClick={() => setUserSort(ele.title)}
                      disabled={ele.disabled}
                    >
                      {ele.title}
                    </MenuItem>
                  );
                })}
              </Menu>
            </div>
            <Image
              src={require("../../../../../assets/images/iconButton/filterbtn.svg")}
              width="80px"
              alt="Filter"
              title="Filter"
              onClick={handleShowFilter}
            />
            <CSVDownloader
              headers={downloadData.headers}
              data={downloadData.data}
              filename={"user_fav_restaurants"}
            />
          </div>
        </div>
        <div className="col-5"></div>
        <div className="col-3 d-flex justify-content-end">
          <div className="mr-3">
            <SelectFilter onDateChange={onDateChangeHandler} />
          </div>
        </div>
      </div>

      {displaySearch ? (
        <React.Fragment>
          <ZoomDiv>
            <div className="mt-2">
              <Form.Control
                type="text"
                placeholder="Search"
                name="search"
                onChange={onSearchChange}
                value={state.search}
                className="amSearch"
              />
            </div>
          </ZoomDiv>
        </React.Fragment>
      ) : null}
      {showFilter && (
        <div className="col-12  mt-3">
          <div className="enWhiteBox mt-3">
            <Form className="row justify-content-between">
              <Col md={5}>
                <Form.Group>
                  <FormControl variant="outlined" className="w-100">
                    <InputLabel htmlFor="outlined-Offer">Status</InputLabel>
                    <Select
                      value={statusType}
                      onChange={(e) => setstatusType(e.target.value)}
                      label="Offer"
                      inputProps={{
                        name: "Offer",
                        id: "outlined-Location",
                      }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      {statusTypes.map((data) => {
                        return (
                          <option value={data.title} key={data.id}>
                            {data.title}
                          </option>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Form.Group>
              </Col>
              <Col>
                <div className="d-flex align-items-center">
                  <Button
                    variant="outline-secondary"
                    className="btn-lg mr-4 px-5"
                    onClick={cancelClick}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="danger"
                    className="btn-lg px-5"
                    onClick={searchClick}
                  >
                    Apply Filter
                  </Button>
                </div>
              </Col>
            </Form>
          </div>
        </div>
      )}
      <hr />
      <div className="col-12">
        <div className="d-flex align-items-center">
          <Button
            variant="link"
            className={`px-0 mr-4 text-grayLink f12-500 ${props.selectedTab === 1 ? "active" : ""
              }`}
            onClick={() => props.pageChanger(1)}
          >
            Restaurants
          </Button>
          <Button
            variant="link"
            className={`px-0 mr-4 text-grayLink f12-500 ${props.selectedTab === 2 ? "active" : ""
              }`}
            onClick={() => props.pageChanger(2)}
          >
            Offers
          </Button>
          <Button
            variant="link"
            className={`px-0 mr-4 text-grayLink f12-500 ${props.selectedTab === 3 ? "active" : ""
              }`}
            onClick={() => props.pageChanger(3)}
          >
            Events
          </Button>
        </div>
      </div>
      <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
        <Table className="HideShowTable enMinWidth900">
          <thead>
            <UserFavoritesRestaurantTableHead
              headOne={<>Business Name <br />/Location/ID</>}
              headTwo="User Name"
              headThree="Date - Time"
              headFour="Status"
            />
          </thead>
          {filteredData?.length ? filteredData.slice(start, end).map((restaurant, index) => (
            <tbody key={index}>{renderTableDataBody(restaurant)}</tbody>
          )) : <NoContent />}
        </Table>
      </div>

      {props.userRestaurantFavourites.length !== 0 ? (
        <BasicPagination
          totalRecords={props.userRestaurantFavourites.length}
          limit={10}
          batch={page}
          onBatchChange={(e) => handleBatchChange(e)}
        />
      ) : (
        <> </>
      )}
    </React.Fragment>
  );
};

UserFavoritesRestaurant.propTypes = {
  auth: PropTypes.object.isRequired,
  getAllFavouritesRestaurant: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  userRestaurantFavourites: state.userManagement.userRestaurantFavourites,
});

export default connect(mapStateToProps, {
  getAllFavouritesRestaurant,
})(UserFavoritesRestaurant);
